import { writable } from 'svelte/store';

export const highlightedEventState = writable({
    enabled : false,
    events : []
});